import type { ReactNode } from 'react';

export const symbol_aq: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M657-275q-78 0-132-54t-54-132q0-77 54-131.5T656-647q77 0 130.5 54.5T840-461q0 40-16 76t-45 63l14 20q5 8 3.5 17t-9.5 15q-8 6-18.5 4.5T753-275l-13-20q-20 10-40.5 15t-42.5 5ZM209-375l-27 75q-3 8-9.5 12.5T158-283q-14 0-22-11t-3-24l113-302q3-9 11-14t17-5h22q9 0 17 5t11 14l114 301q5 13-3 24.5T413-283q-8 0-15-5t-10-13l-27-74H209Zm447 52q15 0 28.5-3t27.5-10l-30-46q-5-8-3.5-17.5T688-414q8-6 18-4t15 10l29 43q19-20 29.5-44.5T790-461q0-57-38.5-97.5T656-599q-57 0-96 40.5T521-461q0 57 39 97.5t96 40.5ZM226-423h118l-57-160h-4l-57 160Z"
		/>
	</svg>
);
